import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3ee0cc40")
const _hoisted_1 = { class: "card-img" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
_popScopeId()


export default /*#__PURE__*/_defineComponent({
  props: {
  img: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "card-img__image",
      src: props.img,
      alt: "Card image"
    }, null, 8, _hoisted_2),
    _createElementVNode("strong", {
      class: "card-img__title",
      textContent: _toDisplayString(props.title)
    }, null, 8, _hoisted_3),
    _createElementVNode("p", {
      class: "card-img__subtitle",
      textContent: _toDisplayString(props.subtitle)
    }, null, 8, _hoisted_4)
  ]))
}
}

})